module.exports = __webpack_public_path__ + "img/arch-logo.0b15e704.jpg";